// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/AboutImage/about_img/mission.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/AboutImage/about_img/solar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mission_main_section__drPmN {
  margin: 4rem 0;
}

.mission_right_section__1\\+bgC {
  position: relative;
  width: 100%;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}

.mission_right_section__1\\+bgC::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30%; 
  background: linear-gradient(
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.5) 
  );
  z-index: 1;
}


.mission_leftSection__Um06L {
  position: relative;
  width: 100%;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}


.mission_leftSection__Um06L::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%; 
  background: linear-gradient(
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.5)
  );
  z-index: 1;
}


.mission_textOverlay__xJiQk {
  padding: 1rem;
  width: 100%;

  & h6 {
    color: var(--text-color);
    font-family: inter;
    font-size: 1.5rem;
    margin: 0 0 0.5rem;
  }

  & p {
    color: var(--text-color);
    font-family: inter;
    font-size: 1rem;
    margin: 0;
  }
}

.mission_list__-CJjM {
  margin: 1rem 0;

  & ul {
    padding-left: 0.6rem;
  }

  & li {
    padding: 0.6rem 0;
    font-family: Inter;
    font-size: 0.9rem;
    font-weight: 500;
  }

  & p {
    padding: 0.6rem 0;
    font-family: Inter;
    font-size: 0.9rem;
    font-weight: 500;
  }
}

/* ---------media-queries------------ */

@media screen and (max-width: 568px) {
  .mission_main_section__drPmN {
    margin: 2rem 0;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/Components/Mission/mission.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yDAAwE;EACxE,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX;;;GAGC;EACD,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yDAAsE;EACtE,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,qBAAqB;EACrB,2BAA2B;AAC7B;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX;;;GAGC;EACD,UAAU;AACZ;;;AAGA;EACE,aAAa;EACb,WAAW;;EAEX;IACE,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE,cAAc;;EAEd;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,uCAAuC;;AAEvC;EACE;IACE,cAAc;EAChB;;AAEF","sourcesContent":[".main_section {\n  margin: 4rem 0;\n}\n\n.right_section {\n  position: relative;\n  width: 100%;\n  height: 400px;\n  background-image: url(\"/public/images/AboutImage/about_img/mission.png\");\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n}\n\n.right_section::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 30%; \n  background: linear-gradient(\n    rgba(0, 0, 0, 0),\n    rgba(0, 0, 0, 0.5) \n  );\n  z-index: 1;\n}\n\n\n.leftSection {\n  position: relative;\n  width: 100%;\n  height: 400px;\n  background-image: url(\"/public/images/AboutImage/about_img/solar.png\");\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n}\n\n\n.leftSection::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40%; \n  background: linear-gradient(\n    rgba(0, 0, 0, 0),\n    rgba(0, 0, 0, 0.5)\n  );\n  z-index: 1;\n}\n\n\n.textOverlay {\n  padding: 1rem;\n  width: 100%;\n\n  & h6 {\n    color: var(--text-color);\n    font-family: inter;\n    font-size: 1.5rem;\n    margin: 0 0 0.5rem;\n  }\n\n  & p {\n    color: var(--text-color);\n    font-family: inter;\n    font-size: 1rem;\n    margin: 0;\n  }\n}\n\n.list {\n  margin: 1rem 0;\n\n  & ul {\n    padding-left: 0.6rem;\n  }\n\n  & li {\n    padding: 0.6rem 0;\n    font-family: Inter;\n    font-size: 0.9rem;\n    font-weight: 500;\n  }\n\n  & p {\n    padding: 0.6rem 0;\n    font-family: Inter;\n    font-size: 0.9rem;\n    font-weight: 500;\n  }\n}\n\n/* ---------media-queries------------ */\n\n@media screen and (max-width: 568px) {\n  .main_section {\n    margin: 2rem 0;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_section": `mission_main_section__drPmN`,
	"right_section": `mission_right_section__1+bgC`,
	"leftSection": `mission_leftSection__Um06L`,
	"textOverlay": `mission_textOverlay__xJiQk`,
	"list": `mission_list__-CJjM`
};
export default ___CSS_LOADER_EXPORT___;
